import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Card, CardBody, CardHeader, Button, Row } from "reactstrap";
import Spinner from "../../Common/Spinner";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Mail, Copy } from "react-feather";
import {
  fetchRecruiterInvitesRequest,
  resetFetchRecruiterInvites,
} from "../../../redux/recruiter/fetch_recruiter_invite/actions";
import { PreloaderContext } from "../../../_helper/Preloader/PreloaderContext";
import { showToast } from "../../Common/Toast";
import { showSweetAlert } from "../../Common/SweetAlert";
import { Link } from "react-router-dom";
import {
  customStyles,
  emptyField,
  LOADER_TIMEOUT,
  getCandidateStatusColor,
} from "../../../Constant";
import {
  formatDate,
  handleSendEmail,
  handleCopyToClipboard,
  unslugAndCapitalize,
} from "../../../Components/Common/CommonFunction";
import NoDataFound from "../../Common/NoDataFound";
import InviteModal from "./InviteModal";
import { FaClockRotateLeft } from "react-icons/fa6";
import {
  inviteRecruiterRequest,
  resetInviteRecruiter,
} from "../../../redux/recruiter/invite_recruiter/actions";
import { FcAcceptDatabase } from "react-icons/fc";
const InviteRecruiter = () => {
  const navigate = useNavigate();
  const { candidateStatus } = useParams();
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const [selectedIds, setSelectedIds] = useState([]);
  const dispatch = useDispatch();
  const { showPreloader } = useContext(PreloaderContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [showInvite, setInvite] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const fetchRecruiterInviteReducerData = useSelector(
    (state) => state.fetchRecruiterInviteReducer
  );

  const handlePageChange = (page) => setCurrentPage(page);
  const handlePerRowsChange = (newPerPage) => setPerPage(newPerPage);

  // const handleDelete = (seeker_id) => {
  //   showSweetAlert("confirm", {
  //     message: "You want to delete the candidate",
  //     fun: deleteJob,
  //     id: seeker_id,
  //   });
  // };

  // const deleteJob = (seeker_id) => {
  //   // dispatch(deleteCandidateRequest({ seeker_id }));
  // };

  const handleRowSelected = (selectedRows) => {
    const selectedIds = selectedRows.selectedRows.map((row) => row.seeker_id);
    setSelectedIds(selectedIds);
  };

  const handelReInviteClick = (row) => {
    dispatch(inviteRecruiterRequest({ invitation_id: row.invitation_id }));
  };

  const handelApprovedClick = (row) => {
    navigate(`/job/invite/${row.invitation_token}`);
  };

  const inviteRecruiterReducerData = useSelector(
    (state) => state.inviteRecruiterReducer
  );
  // State to hold success/error messages to show below the table
  const [messages, setMessages] = useState([]);
  console.log("messages", messages);
  useEffect(() => {


    let newMessages = [];
    if (inviteRecruiterReducerData.status) {
      // If `status` is true and `data` is available
      if (inviteRecruiterReducerData.data) {
        if (Array.isArray(inviteRecruiterReducerData.data)) {
          // Map over the array to create new message objects
          newMessages = inviteRecruiterReducerData.data.map((msg) => ({
            status: msg.status,
            message: msg.message,
            email: msg.email || "",
          }));
        }

        // If messages have changed, update state
        if (newMessages.length > 0 && JSON.stringify(messages) !== JSON.stringify(newMessages)) {
          setMessages(newMessages);
        }

        // Dispatch actions if required
        dispatch(resetInviteRecruiter());
        dispatch(fetchRecruiterInvitesRequest(currentPage, perPage, sortColumn, sortDirection));

        // Clear messages after 5 seconds (only if messages were updated)
        const timeoutId = setTimeout(() => {
          setMessages([]);
        }, 5000);

        return () => clearTimeout(timeoutId);
      }

      // If no data but there's a message, create a new message
      if (inviteRecruiterReducerData.message) {
        newMessages = [
          {
            status: inviteRecruiterReducerData.status,
            message: inviteRecruiterReducerData.message,
            email: "", // optional
          },
        ];

        // Only update messages if they have changed
        if (newMessages.length > 0 && JSON.stringify(messages) !== JSON.stringify(newMessages)) {
          setMessages(newMessages);
        }

        dispatch(fetchRecruiterInvitesRequest(currentPage, perPage, sortColumn, sortDirection));
        dispatch(resetInviteRecruiter());
      }
    }
    // Clear messages after 5 seconds if there's an error
    const timeoutId = setTimeout(() => {
      setMessages([]);
    }, 5000);

    return () => clearTimeout(timeoutId);

  }, [
    inviteRecruiterReducerData,

  ]);



  const tableColumns = [
    {
      name: "#",
      cell: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "60px",
      // sortable: true,
    },
    {
      name: "Email",
      // short_column: "invite_email",
      // sortable: true,
      //   width: "180px",
      cell: (row) => (
        <>
          {row.invite_email ? (
            <span style={{ cursor: "pointer" }}>
              {row.invite_email && (
                <div className="mb-2">
                  {emptyField(row.invite_email.trim()).length > 15
                    ? `${emptyField(row.invite_email.trim()).substring(
                      0,
                      15
                    )}...`
                    : emptyField(row.invite_email.trim())}
                  <Mail
                    size={18}
                    className="email-icon"
                    style={{
                      marginLeft: "5px",
                      marginRight: "5px",
                      cursor: "pointer",
                      verticalAlign: "middle",
                    }}
                    onClick={() => handleSendEmail(row.invite_email)}
                  />
                  <Copy
                    size={18}
                    className="copy-icon"
                    style={{
                      marginLeft: "5px",
                      cursor: "pointer",
                      verticalAlign: "middle",
                    }}
                    onClick={() => handleCopyToClipboard(row.invite_email)}
                  />
                </div>
              )}
            </span>
          ) : (
            "-"
          )}
        </>
      ),
    },
    {
      name: "Status",
      center: true,
      cell: (row) => (
        <span className={`badge ${getCandidateStatusColor(row.status)}`}>
          {unslugAndCapitalize(row.status)}
        </span>
      ),
    },
    {
      name: "Source",
      center: true,
      cell: (row) => (
        <span className="badge bg-light text-dark">
          {(row.source || "INVITATION").toString().replace(/_/g, " ").toUpperCase()}
        </span>
      ),
    },
    {
      name: "Sent On",
      center: true,
      short_column: "sent_at",
      sortable: true,
      //  width: "120px",
      cell: (row) => formatDate(row.sent_at) || "-",
    },
    {
      name: "Action",
      center: true,
      //  width: "120px",
      cell: (row) => {
        const showAccept = row.status === "PENDING" && row.recruiter_id !== user_data.recruiter_id;
        const showReinvite = !["REGISTERED", "ACCEPTED"].includes((row.status || "").toUpperCase());

        if (!showAccept && !showReinvite) {
          return <span>-</span>;
        }

        return (
          <div>
            <span>
              {showAccept && (
                <Link to={`/job/invite/${row.invitation_token}`}>
                  <span>
                    <FcAcceptDatabase
                      size={25}
                      className="resend-icon me-2"
                      title="Accept"
                    />
                  </span>{" "}
                </Link>
              )}
              {showReinvite && (
                <span>
                  <FaClockRotateLeft
                    size={18}
                    onClick={() => {
                      handelReInviteClick(row);
                    }}
                    className="resend-icon"
                    title="Re Sent"
                  />
                </span>
              )}
            </span>
          </div>
        );
      },
    },
  ];

  const toggleInviteModal = () => setInvite(false);
  const handelInviteClick = () => setInvite(true);





  const handleSort = async (column, direction) => {
    setSortColumn(column.short_column);
    setSortDirection(direction);
    // fetchJobs(); // Fetch jobs with new sorting

  };

  useEffect(() => {

    dispatch(fetchRecruiterInvitesRequest(currentPage, perPage, sortColumn, sortDirection));
  }, [perPage, currentPage, sortColumn, sortDirection]);

  useEffect(() => {
    if (messages.length > 0) {
      const timeoutId = setTimeout(() => {
        setMessages([]);
      }, 5000);

      return () => clearTimeout(timeoutId); // cleanup
    }
  }, [messages]);

  return (
    <Fragment>
      <Row>
        <Col xs="12" className="box-col-12 xl-100">
          {/* Messages shown below the table */}
          <div >
            {messages.length > 0 &&

              <Card>
                <CardBody>
                  {messages.map((msg, index) => (
                    <div
                      key={index}
                      className={`alert ${msg.status ? "alert-success" : "alert-danger"
                        }`}
                      style={{ marginBottom: "8px" }}
                      role="alert"
                    >
                      {msg.message} {msg.email && `(Email: ${msg.email})`}
                    </div>
                  ))}
                </CardBody>
              </Card>
            }
          </div>
          <Card>
            <CardHeader className="py-3">
              <Button
                color="primary"
                className="float-end"
                onClick={handelInviteClick}
              >
                Invite
              </Button>
            </CardHeader>
            <CardBody className="px-0 py-3">
              <DataTable
                customStyles={customStyles}
                data={fetchRecruiterInviteReducerData.data.data}
                columns={tableColumns}
                striped={true}
                center={true}
                // selectableRows
                // onSelectedRowsChange={handleRowSelected}
                pagination
                paginationServer
                paginationTotalRows={fetchRecruiterInviteReducerData.data.total_count}
                paginationPerPage={perPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                progressPending={fetchRecruiterInviteReducerData.isLoading}
                progressComponent={<Spinner />}
                noDataComponent={<NoDataFound message={"No invites found"} />}
                onSort={(column, direction) => handleSort(column, direction)}
              />
            </CardBody>
          </Card>



        </Col>
      </Row>
      {showInvite && (
        <InviteModal isOpen={showInvite} toggleModal={toggleInviteModal} />
      )}
    </Fragment>
  );
};

export default InviteRecruiter;
